export enum MediumType {
    BankCard = 2,
    SmartToken = 10,
}
